import type { IExercise } from '../exercises';

export const HOME_EPISODE_02_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-home-02-01",
    "name": "俯卧背伸",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "thoracic",
    "tips": ["核心收紧，控制动作节奏", "全程保持稳定"],
    "sets": 2,
    "reps": "15",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["背阔肌", "大圆肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-546b76bad294a51fdca55b5d.mp4",
    "videoUrl": "/media/collections-20261008/videos/4dc0d8f4ce28b0234b848feb.mp4",
    "source": "居家训练 · 第2期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-02-02",
    "name": "引体向上",
    "bodyPart": "back",
    "equipment": "bodyweight",
    "subCategory": "width",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "力竭",
    "rpe": 9,
    "restSeconds": 75,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["背阔肌", "大圆肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-7b74a47a5c88dca4a8ac49f6.mp4",
    "videoUrl": "/media/collections-20261008/videos/0f7d3d4eb6f432fd2974fd5e.mp4",
    "source": "居家训练 · 第2期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-02-03",
    "name": "单臂哑铃划船",
    "bodyPart": "back",
    "equipment": "dumbbell",
    "subCategory": "thickness",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "每侧10-12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["斜方肌中下部", "菱形肌", "背阔肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-959b3122a42e29f50b3bb870.mp4",
    "videoUrl": "/media/collections-20261008/videos/2e45de5146657ea5710ef1bc.mp4",
    "source": "居家训练 · 第2期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-02-04",
    "name": "双哑铃俯身划船",
    "bodyPart": "back",
    "equipment": "dumbbell",
    "subCategory": "thickness",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "8-12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["斜方肌中下部", "菱形肌", "背阔肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-896782037c3b2dedb740ad0a.mp4",
    "videoUrl": "/media/collections-20261008/videos/c3f309b196a6e5121ced6725.mp4",
    "source": "居家训练 · 第2期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-02-05",
    "name": "跪姿健腹轮",
    "bodyPart": "abs",
    "equipment": "ab-wheel",
    "subCategory": "core",
    "tips": ["核心全程收紧", "不塌腰不弓背"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "居家训练 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/mobile-8178938f4f42951d63f2dd9c.mp4",
    "videoUrl": "/media/collections-20261008/videos/704cfa4e3be6ccbc4ee86400.mp4",
    "targetMuscles": ["核心肌群"],
    "difficulty": "beginner",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-02-06",
    "name": "哑铃弯举",
    "bodyPart": "arms",
    "equipment": "dumbbell",
    "subCategory": "biceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱二头肌", "肱肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-2915aefedaef9b1c5048593f.mp4",
    "videoUrl": "/media/collections-20261008/videos/5c050175703cef72509893d5.mp4",
    "source": "居家训练 · 第2期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
